import { ORG_PUBLIC_PATH_PREFIX } from '@court-sync/shared';
import { getOrgHostMode } from './orgPaths';

/** True when the current URL is a unified org public route (path or branded subdomain). */
export function isOrgUnifiedPublicRoute(): boolean {
  if (typeof window === 'undefined') return false;
  const hostMode = getOrgHostMode();
  if (hostMode === 'subdomain') {
    return /^\/book(\/|$)/.test(window.location.pathname);
  }
  return window.location.pathname.startsWith(`${ORG_PUBLIC_PATH_PREFIX}/`);
}

/**
 * Org slug from `/club-academy/:orgSlug/*` path mode, or empty string on org subdomain hosts
 * (slug is not in the path). Returns null when not on a unified org public route.
 */
export function resolveOrgSlugFromPublicPath(): string | null {
  if (!isOrgUnifiedPublicRoute()) return null;
  const hostMode = getOrgHostMode();
  if (hostMode === 'subdomain') {
    return '';
  }
  const escaped = ORG_PUBLIC_PATH_PREFIX.replace(/\//g, '\\/');
  const match = window.location.pathname.match(new RegExp(`^${escaped}/([^/]+)`));
  return match?.[1] ?? null;
}
